export const osnMoreInfoCircleIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C17.5228 22 22 17.5228
 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" stroke-width="2"
 stroke-linecap="square"/><path d="M12 17L12 10" stroke="white" stroke-width="2" stroke-linecap="round"/><circle
 cx="12" cy="7" r="1" fill="white"/></svg>`,
  name: 'more-info-circle',
};
